import { useSelector } from 'react-redux';
import BaseTable from '../../components/BaseTable';
import { fetchStaffAccountsListOrEmpty } from '../../api/careRecords';
import { CARE_TABLE_KIND, useTableColumns } from '../../hooks/columns';
import { useCareList } from '../../hooks/useCareList';

export default function StaffAccess() {
  const token = useSelector((state) => state.auth.token);
  const columns = useTableColumns(CARE_TABLE_KIND.staffAccess);
  const { data, loading, error } = useCareList(
    fetchStaffAccountsListOrEmpty,
    token
  );

  return (
    <div className="care-page">
      <BaseTable
        columns={columns}
        dataSource={data}
        loading={loading}
        error={error}
        searchKeys={['name', 'email', 'role', 'status']}
        searchPlaceholder="Search name, email, role…"
        emptyText="No staff accounts found."
      />
    </div>
  );
}
